export default __webpack_public_path__ + "locales/uk-UA/InfoPanel.json?hash=2522dd092f5645c545e823c12bcf3716";